export default __webpack_public_path__ + "static/media/nodejs-1-logo-svg-vector.299000a0.svg";